// extracted by mini-css-extract-plugin
export var attachment = "_r9-a";
export var emailContainer = "_r9-4";
export var emailContentPaddedContainer = "_r9-b";
export var emailHeader = "_r9-6";
export var emailIframe = "_r9-3";
export var emailInfoIcon = "_r9-9";
export var emailShortenedSummary = "_r9-e";
export var infoDropdown = "_r9-0";
export var infoRowBoundedContent = "_r9-d";
export var internal = "_r9-5";
export var merchant = "_r9-8";
export var messageInputContainer = "_r9-h";
export var normal = "_r9-7";
export var replyCard = "_r9-f";
export var subtleButton = "_r9-1";
export var subtleButtonIconContainer = "_r9-2";
export var toggleViewRepliesButton = "_r9-c";
export var wrappingText = "_r9-g";